import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionGroup, SectionItem, SectionItemValue, SectionItemListaValores } from '@/components/ui'
import type { ResumoSimulacao } from '@/features/proposta/entities/ResumoProposta/resumo-simulacoes-proposta'
import { StringUtils } from '@/utils/string.utils'

type TPropostaCompraContentSacocHProps = {
  resumo: ResumoSimulacao
}

export const PropostaCompraContentSacocH = ({ resumo }: TPropostaCompraContentSacocHProps) => {
  const { t } = useTranslation('proposta')

  return (
    <React.Fragment>
      <SectionGroup withBorder>
        <SectionItem
          label={t('resumo_proposta.proposta_compra.label.valor_total_proposta')}
          colSpan={6}
          withRightBorder
        >
          <SectionItemValue>{resumo.valorProposta}</SectionItemValue>
        </SectionItem>
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.tipo_amortizacao')} colSpan={6} withRightBorder>
          <SectionItemValue>{t('resumo_proposta.proposta_compra.label.sacoch')}</SectionItemValue>
        </SectionItem>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.prazo')} colSpan={6}>
          <SectionItemValue>
            {resumo.prazoEmMeses} {StringUtils.singularPlural(resumo.prazoEmMeses ?? 0, 'mês', 'meses')}
          </SectionItemValue>
        </SectionItem>
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.entrada')}
          valores={resumo.entrada}
          colSpan={6}
        />
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.mensais')}
          valores={resumo.mensais}
          colSpan={6}
          withRightBorder
        />
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.intermediarias')}
          valores={resumo.intermediarias}
          colSpan={6}
        />
      </SectionGroup>
    </React.Fragment>
  )
}
